// Pack counts, split out of `collections.js` on purpose.
//
// `collections.js` statically imports `iconPackData.json` (~251 KB parsed) for the
// editorial content on pack detail pages. `plugins/shortcuts.js` is loaded by the
// harness, so it sits in the entry bundle — and it only ever wanted a count, which
// comes from the small per-version collection files. Importing the count from here
// keeps that 251 KB out of every page load and on the lazy route chunks that
// actually render pack pages.
import collection_data_v5 from './collections-v5.json'
import collection_data_v6 from './collections-v6.json'
import collection_data_v7 from './collections-v7.json'

const COLLECTION_DATA = {
  5: collection_data_v5,
  6: collection_data_v6,
  7: collection_data_v7
}

export function getCollectionData(version) {
  return COLLECTION_DATA[version]
}

export function getIconPacksCount(version) {
  return getCollectionData(version).iconPacks.length
}
